import { ProcessStepsButton, ProcessStepsButtonProps, useUuid } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { DemandCasesBatchReleaseDialog } from '~/components/DemandCasesBatchReleaseDialog/DemandCasesBatchReleaseDialog';

import { useDemandProcessStepsButton, UseDemandProcessStepsButtonProps } from './DemandProcessStepsButton.hooks';

export interface DemandProcessStepsButtonProps extends UseDemandProcessStepsButtonProps {
  size?: ProcessStepsButtonProps['size'];
}

export const DemandProcessStepsButton = ({ size, ...otherProps }: DemandProcessStepsButtonProps) => {
  const id = useUuid();
  const { t } = useTranslation(undefined, { keyPrefix: 'DemandProcessStep' });
  const { steps, batchReleaseOpen, batchReleaseToggle } = useDemandProcessStepsButton(otherProps);

  if (steps && steps.length) {
    return (
      <>
        <ProcessStepsButton
          id={id}
          steps={steps}
          size={size}
          label={t('waitingForSupplierInteraction')}
          labelCompleted={t('noActionRequired')}
        />
        {batchReleaseOpen && (
          <DemandCasesBatchReleaseDialog
            demandId={otherProps.demandId}
            open={batchReleaseOpen}
            onClose={() => {
              batchReleaseToggle();
            }}
          />
        )}
      </>
    );
  }
  return null;
};
